// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SortSelect_sort__yRDq7 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.SortSelect_sort--title__cp5Ve {
  color: var(--dark-grey);
  font-weight: 600;
}
.SortSelect_sort--btn__5pzxi {
  font-size: 14px;
  text-transform: initial;
}
.SortSelect_sort--btn__5pzxi .ant-btn-icon {
  height: 16px;
}
.SortSelect_sort--btn__5pzxi .ant-btn-icon svg {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SortSelect/SortSelect.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;AACE;EACE,uBAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,uBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAEM;EACE,eAAA;AAAR","sourcesContent":[".sort {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  &--title {\n    color: var(--dark-grey);\n    font-weight: 600;\n  }\n\n  &--btn {\n    font-size: 14px;\n    text-transform: initial;\n\n    :global(.ant-btn-icon) {\n      height: 16px;\n\n      svg {\n        font-size: 16px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sort": `SortSelect_sort__yRDq7`,
	"sort--title": `SortSelect_sort--title__cp5Ve`,
	"sort--btn": `SortSelect_sort--btn__5pzxi`
};
export default ___CSS_LOADER_EXPORT___;
